import { render, staticRenderFns } from "./admin-dashboard-icon.vue?vue&type=template&id=7edf3503&"
import script from "./admin-dashboard-icon.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports